import axios from 'axios';



export const  axios_eventstracks_getall = async (role)=>{
    return  await axios.post(`/eventstracks/getall/`,{"role":role},{headers:{'Accept':'application/json',"Content-Type":"application/json"}});
}


export const  axios_eventstracks_updateread = async (id)=>{
    return  await axios.post(`/eventstracks/updateread/`,{"id":id},{headers:{'Accept':'application/json',"Content-Type":"application/json"}});
}